const KEY = "delivery_instruction_crouton_displayed";
const VALUE = "true";

export const updateSessionStorageAfterCroutonClick = (): void => {
    sessionStorage.setItem(KEY, VALUE);
};

export const hasSeenDICrouton = (): boolean => sessionStorage.getItem(KEY) === VALUE;
